<template>
    <div class="form-group position-relative" v-if="IsShow">
        <h5 class="CPSForm-label" :class="{ 'floatedLabel': (floatedLabel || $attrs['placeholder'] || temp_value) }">
            {{ labelText }}<span class="text-danger" v-if="isHideStar ? !isHideStar : validationRules"> *</span></h5>
        <validation-provider name="DateTime" :rules="validationRules" v-slot="validationContext"
            :vid="ControlId ? ControlId : ''">
            <datepicker v-model="temp_value" @input="updateValue" @change="updateValue" v-bind="$attrs" :clear-button="true"
            :calendar-button="showDataIcon"  
            calendar-button-icon="fa fa-calendar"
            :placeholder="placeholder"
                :input-class="getValidationStateClass(validationContext)" @blur="checkValue" :disabled-dates="disabledDates">
            </datepicker>
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{mandatoryText}}
            </b-form-invalid-feedback>
        </validation-provider>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Datepicker from 'vuejs-datepicker';
export default {
    props: ["value", "ControlId", "isshow", "mandatory", "title", "disabledDates","isHideStar","placeholder"],
    components: {
        Datepicker
    },
    data() {
        return {
            temp_value: this.value,
            IsShow: true,
            labelText: this.title,
            mandatoryText: this.mandatory,
            validationRules: this.mandatory == null ? null : { required: true },
            floatedLabel: this.checkValue(),
            showDataIcon:true,
        }
    },
    computed: {
        ...mapGetters({
            GetPermissionJsonById: 'responsePermission/getPermissionJsonById',
        }),
        record() {
            return this.GetPermissionJsonById({ ControlId: this.ControlId })
        },
    },
    watch: {
        value() {
            this.temp_value = this.value;
            if(this.temp_value) this.showDataIcon=false
            else this.showDataIcon=true

        }
    },
    mounted() {
        //read from json
        if (this.record != null) {
            if (this.record.IsShow != null) this.IsShow = this.record.IsShow;
            if (this.record.IsMandatory) this.validationRules = { required: true };
            if (this.record.IsDisable != null) this.$attrs["disabled"] = this.record.IsDisable;
            if (this.record.Label != null) this.labelText = this.$t(this.record.Label);
            // if(this.record.PlaceholderLabel != null) this.$attrs["placeholder"] = this.record.PlaceholderLabel;
            // if(this.record.MandatoryLabel != null) this.mandatoryText = this.record.PlaceholderLabel;
            // if(this.record.MaxLength != null) this.$attrs["maxlength"] = this.record.MaxLength;
            // if(this.record.MinLength != null) this.$attrs["minlength"] = this.record.MinLength;
        }
    },
    methods: {
        OpenDatepicker()
        {
            this.showDataIcon=true;
        },
        closeDatepicker()
        {
            this.showDataIcon=false;
        },
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
        getValidationStateClass({ dirty, validated, valid = null }) {
            if (this.getValidationState({ dirty, validated, valid })) {
                return "form-control is-valid";
            }
            else {
                return "form-control";
            }
        },
        updateValue(e) {
            this.$emit("input", this.temp_value);
        },
        focusInput() {
            this.floatedLabel = true;
        },
        checkValue() {
            if (this.temp_value != undefined && this.temp_value.length > 0) {
                this.floatedLabel = true;
            } else {
                this.floatedLabel = false;
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.DataIconClass
{

}
</style>